import { render, staticRenderFns } from "./CustomerAttributesComponent.vue?vue&type=template&id=4f2457a0&"
import script from "./CustomerAttributesComponent.vue?vue&type=script&lang=js&"
export * from "./CustomerAttributesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports